import { all, call, put, take } from 'redux-saga/effects';
import { LOAD_BOOKING_LIST } from '../type';
import {
  loadBookingListSuccessAction,
  loadBookingListErrorAction,
} from '../action';

import { bookingService } from 'services';

function* loadBookingList() {
  while (1) {
    const action = yield take(LOAD_BOOKING_LIST);
    try {
      const bookingList = yield call(
        bookingService.loadBookingList,
        action.payload,
      );
      yield put(loadBookingListSuccessAction(bookingList));
    } catch (err) {
      yield put(loadBookingListErrorAction(err));
    }
  }
}
export default function* rootSaga() {
  yield all([loadBookingList()]);
}
